import axiosInstance from "./axios";

export class ReporteService {
    getAsistenciaAlumnos(ciclo, fechadesde, fechahasta) {
        return axiosInstance
            .get(`/reporte/asistenciaalumnos`, { params: { ciclo, fechadesde, fechahasta } })
            .then((res) => res.data)
    }

    getUsuarioAlumno(alumnoId) {
        return axiosInstance
            .get(`/reporte/obtencionUsuarioAlumno`, { params: { alumno: alumnoId } })
            .then((res) => res.data)
    }

    getAsistencias(usuarioId, fechadesde, fechahasta) {
        return axiosInstance
            .get(`/reporte/obtencionAsistencias`, { params: { usuario: usuarioId, fechadesde, fechahasta } })
            .then((res) => res.data)
    }

    getSesionAlumno(nombreusuario) {
        return axiosInstance
            .get(`/reporte/sesionAlumno`, { params: { nombreusuario } })
            .then((res) => res.data)
    }

    getAllExamAlumno(alumnoId) {
        return axiosInstance
            .get(`/reporte/obtenerAllExamAlumno`, { params: { alumno: alumnoId } })
            .then((res) => res.data)
    }
}
